
/**
 * Made to detect if the browser's history was popped (e.g., back button pressed).
 * window.history.state.didHistoryPop will be true from the moment the back button is pressed until the next page finished loading
 * Useful for handling specific logic when the user navigates back in history (before the page is fully loaded)
 */
declare global {
  interface Window {
    didHistoryPop: boolean
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  window.addEventListener('popstate', () => {
    window.didHistoryPop = true
  })

  nuxtApp.hook('page:finish', () => {
    window.didHistoryPop = false
  })
})